import styled from 'styled-components';


export const Div = styled.div`
    width:100%;
    height: 500px;
`